import { api } from "core/axios/axios";




export async function getDatesForTheImageRes() {
    return api.get("cloudfront-image-date");
}



export async function getImagesByDateRes(date: string) {
    return api.get("cloudfront-image-date/imagefile?image_date=" + date);
}



export async function getPreImgUrlRes(ext: string) {
    return api.get("cloudfront-image-upload?extension=" + ext);
}

export async function uploadImageToS3Res(url: string, formData: FormData) {
    const res = await fetch(url, {
        method: "POST",
        body: formData,
    });
    if (!res.ok) {
        throw new Error(`S3 upload failed: ${res.status} ${await res.text().catch(() => "")}`);
    }
    return res;
}